import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Steps from "@/components/common/Steps";
import Breadcrumb from "@/components/specific/Breadcrumb";
import { selectCurrentStep } from "@/store/redux/slices/roles/role_slice";

const AddRolesLayout = () => {
  const location = useLocation();
  const isEditMode = location.pathname.includes("/roles/edit/");
  const steps = [
    { title: "Role Information" },
    { title: "Role Privileges" },
    { title: "Review and Submit" },
  ];

  const currentStep = useSelector(selectCurrentStep);

  // breadcrumb items
  const items = [
    { title: "Roles Management", link: "dashboard/roles" },
    { title: isEditMode ? "Edit Role" : "Add New", link: "" },
  ];

  return (
    <div className="w-full py-6 text-left lg:grid lg:grid-cols-4 lg:gap-10 sm:py-0">
      {/* Mobile Steps - showing all step circles but only active step title */}
      <div className="mb-6 lg:hidden">
        <Steps current={currentStep - 1} steps={steps} />
      </div>

      {/* Main Content Area */}
      <div className="col-span-3  lg:border-r">
        <Breadcrumb items={items} />
        <Outlet />
      </div>

      {/* Desktop Steps - vertical layout showing all steps */}
      <div className="hidden lg:block mt-10 sticky top-[74px] h-[90vh]">
        <Steps current={currentStep - 1} steps={steps} />
      </div>
    </div>
  );
};

export default AddRolesLayout;
